import { render } from "./DirectivesNavBadge.vue?vue&type=template&id=28626275&scoped=true"
import script from "./DirectivesNavBadge.vue?vue&type=script&lang=js"
export * from "./DirectivesNavBadge.vue?vue&type=script&lang=js"

import "./DirectivesNavBadge.vue?vue&type=style&index=0&id=28626275&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28626275"]])

export default __exports__